import { useEffect } from "react";
import { useState } from "react";
import { Panel, PanelGroup } from "rsuite";
import api from "../../../../config/api";
import PreferenceTableLine from "./PreferenceTableLine";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const PreferenceTable = ({ preferences, getPreferences, categorySelected }) => {
  const [preferencesList, setPreferencesList] = useState(() => preferences);
  const [rotated, setRotated] = useState([0, false]);

  useEffect(() => {
    setPreferencesList(() => preferences);
  }, [preferences]);

  const handleDelete = async (index) => {
    let newPreferences = preferencesList;
    newPreferences.preferences.splice(index, 1);
    setPreferencesList(() => newPreferences);
    await api.put(`/preferences/${preferences._id}`, { preferences: newPreferences.preferences }).then((resp) => {
      getPreferences(categorySelected);
    });
  };
  return (
    <div className="father-container">
      <PanelGroup accordion defaultActiveKey={1}>
        {preferencesList?.preferences?.length > 0 &&
          preferencesList?.preferences?.map((element, index) => (
            <div key={element._id} className="mb-3">
              <Panel
                onClick={() => setRotated([index, !rotated[1]])}
                className="rounded-bottom-1 bg-cl-cultured-2 "
                header={
                  <div className="d-flex justify-content-between align-items-center ">
                    <span className="ms-3  ff-univanova-bold fz-16">{element.title}</span>
                    <div className="d-flex ms-4 align-items-center me-auto">
                      <FontAwesomeIcon
                        style={{
                          transform: rotated[0] === index && rotated[1] === true ? "rotate(180deg)" : "none",
                          transitionTimingFunction: "ease-in-out",
                        }}
                        icon={faChevronDown}
                        size="sm"
                      />
                    </div>
                    <div className="d-flex align-items-center variation-delete" onClick={() => handleDelete(index)}>
                      <div alt="delete variation" className="me-2 mb-1 variation-delete-image" />
                      <span className="ff-univanova fz-16 me-4">Excluir categoria</span>
                    </div>
                  </div>
                }
                eventKey={element?._id}
                id={element?._id}
              >
                <PreferenceTableLine {...{ element }} />
              </Panel>
            </div>
          ))}
      </PanelGroup>
    </div>
  );
};
export default PreferenceTable;
